import styled, { css } from 'styled-components';

import {
    Card,
    spaceMixin,
    token,
} from '@zillow/constellation';

/* color not in constellation */
// hex: #588EE9
const borderColor = 'rgba(66, 142, 233, .5)';

export const StyledCard = styled(Card)`
    border-radius: 4px;
    margin: ${spaceMixin('xs')} 0;
    padding: ${spaceMixin('sm')} ${spaceMixin('sm')} ${spaceMixin('md')} ${spaceMixin('sm')} ;

    /* override */
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
    border: 0;

    cursor: default;

    ${props => props.isDisabled === false && css`
        cursor: pointer;

        &:hover {
            box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
            /* color not in constellation */
            background-color: #f0faff;
        }

        &:active {
            /* set top, bottom margin = origin margin - border size */
            margin: 6px 0;
            background-color: ${token('colors.blue100')};
            border: 2px solid ${borderColor};
            box-shadow: ${borderColor} 0px 0px 10px;
        }
    `}
`;
